<template>
  <div class="monetization-statistic-card" style="flex-grow: 1;">
    <div class="btn-group mb-4" role="group" aria-label="Basic radio toggle button group">
      <input @change="load('day')" checked type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off">
      <label class="btn btn-outline-success" for="btnradio1">{{ getLocalization('24 hours') }}</label>
      <input @change="load('week')" type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
      <label class="btn btn-outline-success" for="btnradio2">{{ getLocalization('7 days') }}</label>
      <input @change="load('month')" type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off">
      <label class="btn btn-outline-success" for="btnradio3">{{ getLocalization('1 month') }}</label>
    </div>
<!--    <div class="monetization-statistic-card__divider"></div>-->
    <div class="monetization-statistic-card__info" style="flex-flow: row wrap;">
      <div class="mb-3" style="position: relative; min-height: 200px; width: 200px; flex-grow: 1; align-self: flex-start;">
        <DoughnutChart :chart-data="chartData" :width="NaN" :height="NaN" />
        <div v-if="percent!==null" style="position: absolute; top: 50%; left: 50%; color: black; font-size: 32px; transform: translate(-50%, -50%); padding-top: 9px;">
          {{ percent }}%
        </div>
      </div>
      <div class="mt-2" style="flex-grow: 1;">
        <div>{{ getLocalization('Number of cancellations') }}: <strong>{{ cancellations }}</strong></div>
        <div class="mt-3">{{ getLocalization('Number of successful') }}: <strong>{{ successful }}</strong></div>
        <div class="mt-3">{{ getLocalization('Amount of earnings') }}: <strong>{{ amount }}P</strong></div>
      </div>
    </div>
  </div>
</template>

<script>
import DoughnutChart from '../charts/doughnutChart.vue'
import BaseAdminMixin from "../../../admin/components/mixins/BaseAdminMixin.vue";
export default {
  name: "commonStatCard",
  mixins: [
    BaseAdminMixin
  ],
  components: { DoughnutChart },
  props: {
    data: {type: Object, required: true}
  },
  data: function () {
    return {
      mode: 'day',
      chartData: {
        datasets: [{
            data: [40, 20],
            backgroundColor: ['#E5AE6C', '#B96141']
        }]
      },
      cancellations: 0,
      successful: 0,
      amount: 0,
      percent: 0
    }
  },
  mounted() {
    this.parseData(this.data)
  },
  methods: {
    parseData(data) {
      data.count_success = data.count_success || 0
      data.count_received = data.count_received || 0
      data.income = data.income || 0
      data.profit = data.profit || 0
      this.cancellations = data.count_received - data.count_success
      this.successful = data.count_success
      this.amount = (data.income - data.profit).toFixed(2)
      this.chartData.datasets[0].data = [data.count_success, data.count_received - data.count_success]
      this.percent = data.count_received > 0 ? Math.round((data.count_success/data.count_received)*100) : null
    },
    async load(mode) {
      this.parseData(await this.sendRequest(
          '/cabinet/partner/monetizestatistic/period',
          'get',
          {mode}
      ))
    }
  }
}
</script>